<template>
  <v-content class="">
    <SelectedShop v-if="init.branch_flg == 1" :selected_shop_name="selected_shop" :router_param="{ name: 'photo_shops', query: { feature_id: 'photo'}}"></SelectedShop>

    <div class="ma-2 photo" v-if="medias">
      <div v-for="(photo, index) in photoData" :key="index" :class="photo.class + ' photoWrap'">
        <v-card class="pa-0 photocard" v-for="(data, index2) in photo.list" :key="index2">
          <v-img :src="data.thumb" lazy-src="@/assets/nophoto.png" @click="onClickBtn(data, index, index2)" @load="sizeCheck(photo.class, index, index2)">
            <template v-slot:placeholder>
              <v-row class="ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
            </template>
          </v-img>
        </v-card>
      </div>
    </div>

    <v-dialog v-model="dialog" v-if="currentphoto" activator>
      <v-card tile class="noround">
        <v-img class="" :src="currentphoto.src" lazy-src="@/assets/nophoto.png">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-card>
    </v-dialog>
    <!-- NEW_DEV-1779 cyber start -->
    <div v-if="dialog && (currentphoto.caption || currentphoto.url)" transition="fade-transition" class="photoinfo">
      <div v-show="arwup" @click.stop="infoUp()">
        <v-icon color="#fff">fas fa-chevron-up</v-icon>
      </div>
      <div v-show="!arwup" @click.stop="infoUp()">
        <v-icon color="#fff">fas fa-chevron-down</v-icon>
      </div>
      <div class="photosubinfo" v-show="!arwup">
        {{currentphoto.caption}}
        <div v-if="currentphoto.url" class="maincolor" @click.stop="toLink(currentphoto.url)">
          <v-icon x-small class="maincolor">fas fa-link</v-icon> <span v-if="currentphoto.image_link_name">{{currentphoto.image_link_name}}</span><span v-else>{{currentphoto.url}}</span>
        </div>
      </div>
    </div>
    <!-- NEW_DEV-1779 cyber end -->
    <div v-if="dialog && nextArwFlg" class="photoarrow arwnext" @click.stop="photoNext()">
      <v-icon color="#fff">fas fa-chevron-right</v-icon>
    </div>
    <div v-if="dialog && backArwFlg" class="photoarrow arwback" @click.stop="photoBack()">
      <v-icon color="#fff">fas fa-chevron-left</v-icon>
    </div>
    <!-- InfiniteLoading -->
    <infinite-loading ref="infiniteLoading"  @infinite="infiniteHandler" spinner="spiral">
      <div slot="spinner"><v-progress-circular :size="30" :width="2" class="maincolor" indeterminate></v-progress-circular></div>
      <div slot="no-more"></div>
      <div slot="no-results">登録されているPHOTOはありません</div>
    </infinite-loading>
  </v-content>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import SelectedShop from '@/components/selected_shop.vue'
const sleep = ms => new Promise(res => setTimeout(res, ms));
export default {
    components: {
        InfiniteLoading,
        SelectedShop,
    },
    data() {
        return {
            page: 1,
            result: null,
            medias: null,
            init: [],
            currentphoto: null,
            nextphoto: null,
            backphoto: null,
            photoNumber: null,
            dialog: false,
            //NEW_DEV-1779 cyber start
            arwup: true,
            //NEW_DEV-1779 cyber end
            backArwFlg: false,
            nextArwFlg: false,
            photoCount: null,
            photoData: []
        };
    },
    watch: {
      medias: {
        deep: true,
        handler: function (v) {
          if (!v || !v.length) {
            return true;
          }

          this.photoData = [];
          let count = 0;
          for (let i = 0; i < this.medias.length; i++) {
            if (this.photoData.length && this.photoData[count].list.length >= 9) {
              count++;
            }
            if (!this.photoData[(count)] || !this.photoData[(count)].class) {
              this.photoData[(count)] = {
                class: null,
                list: []
              };
            }
            this.photoData[count].list.push(v[i]);
            this.photoData[count].class = 'set' + (this.photoData[count].list.length);
          }
        }
      }
    },
    created() {
        this.init = this.storageGet('*')

        var selected_shop = this.getUrlGetParam('selected_shop');

        if (selected_shop) {
            this.selected_shop = selected_shop
        } else {
            this.selected_shop = '全て'
        }
    },
    methods: {
      async infiniteHandler() {
          this.init = this.storageGet('*')

          var shop_id = this.getUrlGetParam('shop_id');
          var selected_shop = this.getUrlGetParam('selected_shop');

          if (selected_shop) {
              this.selected_shop = selected_shop
          } else {
              this.selected_shop = '全て'
          }

          var params = {
              'page': this.page,
              'preview': this.getUrlGetParam('preview')
          }

          if (shop_id) {
              params['shop_id'] = shop_id
          }

          var reqest_params = { params: params }

          var res = await this.apiCall('/photo/list', reqest_params)

          if (this.page == 1) {
              this.$set(this, 'result', res)
              this.$set(this, 'medias', res.data)
          } else {
            if (res.data && res.data.length > 0) {
              this.medias = this.medias.concat(res.data);
            }
          }

          this.page = this.page + 1

          if (res.data && res.data.length > 0) {
              this.$refs.infiniteLoading.stateChanger.loaded()
          } else {
              this.$refs.infiniteLoading.stateChanger.complete()
          }
      },
      openGallery(index) {
          this.$refs.lightbox.showImage(index);
      },
      onClickBtn(media, index, index2) {
        let tmp = !index ? 0 : 9 * index;
        let number = tmp + index2;
        this.photoNumber = number
        this.nextphoto = this.medias[number+1]
        this.backphoto = this.medias[number-1]
        this.currentphoto = media
        this.dialog = true
        this.photoCount = this.medias.length
        this.Arwflg()
      },
      photoNext(){
        this.currentphoto = this.medias[this.photoNumber+1]
        this.photoNumber++;
        this.Arwflg()
      },
      photoBack(){
        if(this.photoNumber > 0) {
          this.currentphoto = this.medias[this.photoNumber-1]
          this.photoNumber--;
          this.Arwflg()
        }
      },
      //NEW_DEV-1779 cyber start
      infoUp(){
        this.arwup = !this.arwup;
      },
      //NEW_DEV-1779 cyber end
      Arwflg(){
        if(this.photoNumber == 0){
          this.backArwFlg = false
        }else{
          this.backArwFlg = true
        }
        if(this.photoNumber == (this.photoCount - 1)){
          this.nextArwFlg = false
        }else{
          this.nextArwFlg = true
        }
      },
      toLink(url) {
          var req = {
            destination: url,
            transition_type: 4,
          }
          if (!(this.screenTransition(req))) {
            this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
          }
      },
      async sizeCheck (className, i1, i2) {
        let parent = this.$el.getElementsByClassName('photoWrap');
        let child = parent[i1].getElementsByClassName('photocard');
        let img = child[i2].getElementsByClassName('v-image');
        switch (className) {
          case 'set1':
          case 'set2':
            break;
          default:
            if (i2 == 1|| i2 == 2) {
              await sleep(1500);
              img[0].style.height = (Math.floor(child[0].offsetHeight / 2)) + 'px';
            } else if (i2 == 5) {
              await sleep(1500);
              img[0].style.height = (child[4].offsetHeight + 2) + 'px';
            } else if ((className == 'set8' || className == 'set9') && (i2 == 7 || i2 == 8)) {
              await sleep(1500);
              img[0].style.height = child[6].offsetHeight + 'px';
            }

            if (className == 'set9' && i2 >= 6) {
              await sleep(1500);
              let width = parent[i1].offsetWidth;
              img[0].style.width = (Math.floor(width / 3)) + 'px';
            }
        }
      }
    }
};
</script>

<style scoped>
img.thumbnail {
    width: 100%;
    height: auto;
    cursor: pointer;
}
/* NEW_DEV-1779 cyber start */
.photoinfo {
    position: fixed;
    color: #fff;
    background-color: rgba(0, 0, 0, .7);
    height: auto;
    min-height: 40px;
    width: 100%;
    left: 0;
    bottom: 0;
    text-align: center;
    padding: 10px;
    box-sizing: border-box;
    z-index: 500;
}
.v-card.noround:not(.v-sheet--tile):not(.v-card--shaped) {
  border-radius: 0 !important;
}
.photoinfo .photosubinfo{
    height: auto;
    width: 100%;
    text-align: left;
    white-space:normal;
    word-break:break-all;
    word-wrap:break-word;
}
.photoinfo .photosubinfo div {
    display: block;
    text-align: right;
    text-decoration: underline;
}
/* NEW_DEV-1779 cyber end */
.photoarrow {
    position: fixed;
    color: #fff;
    background-color: rgba(0, 0, 0, .7);
    z-index: 400;
    top: 45%;
    padding: 10px;
}
.photoarrow.arwnext {
  right: 0;
}
.photoarrow.arwback {
  left: 0;
}
.photoWrap::after {
  display: block;
  content: '';
  clear: both;
}
.photocard {
  width: 49%;
  float: left;
  margin: 0.5%;
}
.set1 .photocard,
.set2 .photocard,
.set4 .photocard:nth-child(4),
.set5 .photocard:nth-child(4),
.set5 .photocard:nth-child(5),
.set6 .photocard:nth-child(4),
.set7 .photocard:nth-child(4),
.set7 .photocard:nth-child(7),
.set8 .photocard:nth-child(4),
.set9 .photocard:nth-child(4) {
  width: 99%;
  margin: 0.5%;
}
.set9 .photocard:nth-child(9),
.set9 .photocard:nth-child(8),
.set9 .photocard:nth-child(7) {
  width: 32%;
  margin: 0.5%;
}
</style>
